var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4801 15.6364C11.8713 15.6364 12.1885 15.3107 12.1885 14.9091V7.63636C12.1885 7.23476 11.8713 6.90909 11.4801 6.90909C11.089 6.90909 10.7718 7.23476 10.7718 7.63636V14.9091C10.7718 15.3107 11.089 15.6364 11.4801 15.6364Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52181 15.6364C6.91295 15.6364 7.23014 15.3107 7.23014 14.9091V7.63636C7.23014 7.23476 6.91295 6.90909 6.52181 6.90909C6.13067 6.90909 5.81348 7.23476 5.81348 7.63636V14.9091C5.81348 15.3107 6.13067 15.6364 6.52181 15.6364Z",
    fill: "#9B9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8343 1.45455C12.2255 1.45455 12.5426 1.12887 12.5426 0.727273C12.5426 0.325673 12.2255 0 11.8343 0H6.16764C5.7765 0 5.45931 0.325673 5.45931 0.727273C5.45931 1.12887 5.7765 1.45455 6.16764 1.45455H11.8343Z",
    fill: "#9B9B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20931 2.18182C0.818168 2.18182 0.500977 2.50749 0.500977 2.90909C0.500977 3.31069 0.818168 3.63636 1.20931 3.63636H1.91764V17.0182C1.91764 18.6617 3.22098 20 4.82181 20H13.1801C14.7809 20 16.0843 18.6618 16.0843 17.0182V3.63636H16.7926C17.1838 3.63636 17.501 3.31069 17.501 2.90909C17.501 2.50749 17.1838 2.18182 16.7926 2.18182H1.20931ZM14.6676 3.63636V17.0182C14.6676 17.8618 14.0018 18.5455 13.1801 18.5455H4.82181C4.00014 18.5455 3.33431 17.8618 3.33431 17.0182V3.63636H14.6676Z",
    fill: "#9B9B9B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccount);
export default __webpack_public_path__ + "static/media/delete-account.581b46c99ada882ab957392f1d7c58b1.svg";
export { ForwardRef as ReactComponent };